import { useEffect, useState } from 'react';

import Api from '~/Api';

const useUserCountry = (profileCountry: string): string => {
  const [userCountryCode, setUserCountryCode] = useState<string>(
    profileCountry || '',
  );

  useEffect(() => {
    (async (): Promise<void> => {
      if (userCountryCode) return;

      try {
        const country = await Api.getCountry();
        setUserCountryCode(country);
      } catch (error) {
        setUserCountryCode('US');
      }
    })();
  }, [userCountryCode]);

  return userCountryCode;
};

export default useUserCountry;
